import filters from '@/constants/filters';

const addElement = (value, mark, array) => {
    const obj = {
        value,
        mark
    };
    array.push(obj);
};

const filteredPhones = (initialArray, arrayWithObject, targetArray) => {
    let _quantity = 0;
    initialArray.forEach((elem, index) => {
        if (index === 0 || index === 1) {
            addElement(elem, 0, targetArray);
            addElement(' ', 0, targetArray);
        } else {
            for (let i = 0; i < elem.length; i++) {
                targetArray.push(arrayWithObject[_quantity + i]);
            }
            addElement(' ', 0, targetArray);
            _quantity += elem.length;
        }
    });
};

const displayingDifferentPhones = (initialArray, targetArray) => {
    if (initialArray.stored.length > 0) {
        initialArray.stored.forEach((el) => {
            if (!initialArray.displayed.includes(el)) {
                const obj1 = [
                    {
                        value: filters.phone(el),
                        mark: 1
                    }
                ];
                targetArray.push(obj1);
            }
        });
    }
};

const setPhoneForOneFamily = (initialArray, targetArray) => {
    initialArray.forEach((el) => {
        const _arr = [];
        addElement(filters.phone(el.number), 1, _arr);
        targetArray.push(_arr);
    });
};

export const compareTextWithOneFamily = (textOriginal1, textOriginal2, element1, element2) => {
    const text1 = textOriginal1.toLowerCase();
    const text2 = textOriginal2.toLowerCase();
    if (text1.includes(text2)) {
        const index = text1.indexOf(text2);
        if (index === 0) {
            addElement(textOriginal1.substr(0, text2.length), 0, element1);
            addElement(textOriginal1.substr(text2.length), 1, element1);
            addElement(textOriginal2, 0, element2);
        } else if (index > 0) {
            addElement(textOriginal1.substr(0, index), 1, element1);
            addElement(textOriginal1.substr(index, text2.length), 0, element1);
            addElement(textOriginal1.substr(index + text2.length), 1, element1);
            addElement(textOriginal2, 0, element2);
        }
    } else if (text2.includes(text1)) {
        const index = text2.indexOf(text1);
        if (index === 0) {
            addElement(textOriginal2.substr(0, text1.length), 0, element2);
            addElement(textOriginal2.substr(text1.length), 1, element2);
            addElement(textOriginal1, 0, element1);
        } else if (index > 0) {
            addElement(textOriginal2.substr(0, index), 1, element2);
            addElement(textOriginal2.substr(index, text1.length), 0, element2);
            addElement(textOriginal2.substr(index + text1.length), 1, element2);
            addElement(textOriginal1, 0, element1);
        }
    } else {
        compareText(textOriginal1, textOriginal2, element1, element2);
    }
};

export const compareText = (textOriginal1, textOriginal2, element1, element2) => {
    const text1 = textOriginal1.toLowerCase();
    const text2 = textOriginal2.toLowerCase();
    let start;
    const end1 = {
        value: '',
        mark: 0
    };
    const end2 = {
        value: '',
        mark: 0
    };
    if (element1.length === 0 && element2.length === 0) {
        if (text1.length < text2.length) {
            start = text1;
            end2.value = textOriginal2.substring(text1.length);
            end2.mark = 1;
        } else if (text1.length > text2.length) {
            start = text2;
            end1.value = textOriginal1.substring(text2.length);
            end1.mark = 1;
        } else {
            start = text1;
        }
        for (let i = 0; i < start.length; i++) {
            if (text1.charAt(i) === text2.charAt(i)) {
                addElement(textOriginal1.charAt(i), 0, element1);
                addElement(textOriginal2.charAt(i), 0, element2);
            } else {
                addElement(textOriginal1.charAt(i), 1, element1);
                addElement(textOriginal2.charAt(i), 1, element2);
            }
        }
        element1.push(end1);
        element2.push(end2);
    } else if (element1.length !== 0 && element2.length === 0) {
        if (text1.length < text2.length) {
            start = text1;
            end2.value = textOriginal2.substring(text1.length);
            end2.mark = 1;
        } else if (text1.length > text2.length) {
            start = text2;
        } else {
            start = text1;
        }
        for (let i = 0; i < start.length; i++) {
            if (text1.charAt(i) === text2.charAt(i)) {
                addElement(textOriginal2.charAt(i), 0, element2);
            } else {
                if (element1[i]) {
                    element1[i].mark = 1;
                }
                addElement(textOriginal2.charAt(i), 1, element2);
            }
        }
        element2.push(end2);
    }
};

export const comparePhones = (
    maxDifferentAmount,
    initialArray1,
    initialArray2,
    targetArray1,
    targetArray2
) => {
    const elements1 = {
        displayed: [],
        stored: []
    };
    const elements2 = {
        displayed: [],
        stored: []
    };
    if (initialArray1.length === 0) {
        setPhoneForOneFamily(initialArray2, targetArray2);
    } else if (initialArray2.length === 0) {
        setPhoneForOneFamily(initialArray1, targetArray1);
    } else {
        initialArray1.forEach((elem1) => {
            if (!elements1.displayed.includes(elem1)) {
                initialArray2.forEach((elem2) => {
                    if (!elements2.displayed.includes(elem2)) {
                        const phone1Example = filters.phone(elem1.number).split(' ');
                        const phone2Example = filters.phone(elem2.number).split(' ');
                        const phone1 = elem1.number;
                        const phone2 = elem2.number;
                        let amount = 0;
                        const el1 = [];
                        const el2 = [];
                        for (let i = 0; i < phone1.length; i++) {
                            if (phone1.charAt(i) === phone2.charAt(i)) {
                                addElement(phone1.charAt(i), 0, el1);
                                addElement(phone2.charAt(i), 0, el2);
                            } else {
                                addElement(phone1.charAt(i), 1, el1);
                                addElement(phone2.charAt(i), 1, el2);
                                amount += 1;
                            }
                        }
                        const _arrForAdd1 = [];
                        const _arrForAdd2 = [];
                        filteredPhones(phone1Example, el1, _arrForAdd1);
                        filteredPhones(phone2Example, el2, _arrForAdd2);
                        if (amount <= maxDifferentAmount) {
                            targetArray1.push(_arrForAdd1);
                            targetArray2.push(_arrForAdd2);
                            elements1.displayed.push(phone1);
                            elements2.displayed.push(phone2);
                            if (elements1.stored.includes(phone1)) {
                                elements1.stored.splice(elements1.stored.indexOf(phone1), 1);
                            }
                            if (elements2.stored.includes(phone2)) {
                                elements2.stored.splice(elements2.stored.indexOf(phone2), 1);
                            }
                        } else {
                            if (!elements1.stored.includes(phone1)) {
                                elements1.stored.push(phone1);
                            }
                            if (!elements2.stored.includes(phone2)) {
                                elements2.stored.push(phone2);
                            }
                        }
                    }
                });
            }
        });
        displayingDifferentPhones(elements1, targetArray1);
        displayingDifferentPhones(elements2, targetArray2);
    }
};

export const compareMultipleFamiliesPhones = (
    maxDifferentAmount,
    initialArray1,
    initialArray2,
    targetArray1,
    targetArray2
) => {
    if (targetArray1.length === 0 && targetArray2.length === 0) {
        comparePhones(maxDifferentAmount, initialArray1, initialArray2, targetArray1, targetArray2);
    } else if (targetArray1.length !== 0 && targetArray2.length === 0) {
        const elements2 = {
            displayed: [],
            stored: []
        };
        initialArray1.forEach((elem1) => {
            initialArray2.forEach((elem2) => {
                if (!elements2.displayed.includes(elem2)) {
                    const phone2Example = filters.phone(elem2.number).split(' ');
                    const phone1 = elem1.number;
                    const phone2 = elem2.number;
                    let amount = 0;
                    const el2 = [];
                    for (let i = 0; i < phone1.length; i++) {
                        if (phone1.charAt(i) === phone2.charAt(i)) {
                            addElement(phone2.charAt(i), 0, el2);
                        } else {
                            addElement(phone2.charAt(i), 1, el2);
                            amount += 1;
                        }
                    }
                    const _arrForAdd2 = [];
                    filteredPhones(phone2Example, el2, _arrForAdd2);
                    if (amount <= maxDifferentAmount) {
                        targetArray2.push(_arrForAdd2);
                        elements2.displayed.push(phone2);
                        if (elements2.stored.includes(phone2)) {
                            elements2.stored.splice(elements2.stored.indexOf(phone2), 1);
                        }
                    } else {
                        if (!elements2.stored.includes(phone2)) {
                            elements2.stored.push(phone2);
                        }
                    }
                }
            });
        });
        displayingDifferentPhones(elements2, targetArray2);
    }
};
